import { render } from "./Acts.vue?vue&type=template&id=498a8690"
import script from "./Acts.vue?vue&type=script&lang=js"
export * from "./Acts.vue?vue&type=script&lang=js"

import "./Acts.vue?vue&type=style&index=0&id=498a8690&lang=scss"

import exportComponent from "/builds/boikovky/medsafe-stat-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__